import { render, staticRenderFns } from "./CompanyAdditionalList.vue?vue&type=template&id=e69548a6&"
import script from "./CompanyAdditionalList.vue?vue&type=script&lang=js&"
export * from "./CompanyAdditionalList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports